import(/* webpackMode: "eager" */ "/home/user2/Desktop/MDM/UdmsClient/uss/src/app/i18n/client.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/user2/Desktop/MDM/UdmsClient/uss/src/components/common/LanguageProvider.jsx");
;
import(/* webpackMode: "eager" */ "/home/user2/Desktop/MDM/UdmsClient/uss/src/styles/index.css");
